import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Img from 'gatsby-image';

import { fadeIn } from '../constants/keyframes';
import { TRANSITION_TIME_TOTAL } from '../constants/transitions';
import { fluidPropTypes } from '../types';

import DuoToneImage from './DuoToneImage';
import GrayImage from './GrayImage';


const AnimatedGrayImage = styled(GrayImage)`
  opacity: 0;
  will-change: opacity;
  animation: ${fadeIn} .6s linear ${TRANSITION_TIME_TOTAL}ms forwards;
`;

const MichelbergerImage = ({ changesColorOnHover, hasBlendMode, image }) => {
  if (image.inlineSvg) {
    return (
      <div dangerouslySetInnerHTML={{ __html: image.inlineSvg }} />
    );
  }

  if (hasBlendMode && changesColorOnHover) {
    return <DuoToneImage key={image.id} image={image} />;
  } if (hasBlendMode && !changesColorOnHover) {
    return <AnimatedGrayImage><Img key={image.id} fluid={image.fluid} /></AnimatedGrayImage>;
  }

  return <Img key={image.id} fluid={image.fluid} />;
};

MichelbergerImage.propTypes = {
  changesColorOnHover: PropTypes.bool,
  hasBlendMode: PropTypes.bool,
  image: PropTypes.shape({
    id: PropTypes.string,
    fluid: fluidPropTypes,
    inlineSvg: PropTypes.string,
  }),
};

export default MichelbergerImage;
